// navigationAction.js
'use strict';
import {
  push as historyPush,
  replace as historyReplace,
} from 'redux-first-history';

import getToObject from '../resource/getToObject.js';
import { generateLangPath, getLangFromPath } from '../resource/langPath.js';
import getRouterData from '../selector/getRouterData.js';

/**
 * Wrap history.push action, try to keep `lang` query
 * @kind action
 * @param {string|Path} to - destination url.
 * @param {any} state - data to associate with new location.
 * @return {Promise} Action promise.
 */
export const push = (to, state) => async (dispatch, getState) => {
  const toObject = getToObject({ to });
  if (toObject.pathname) {
    const currentPathname = getRouterData(getState(), ['location', 'pathname']);
    const currentLang = getLangFromPath(currentPathname);
    toObject.pathname = generateLangPath(toObject.pathname, currentLang);
  }
  return dispatch(historyPush(toObject, state));
};

/**
 * Wrap history.replace action, try to keep `lang` query
 * @kind action
 * @param {string|Path} to - destination url.
 * @param {any} state - data to associate with new location.
 * @return {Promise} Action promise.
 */
export const replace = (to, state) => async (dispatch, getState) => {
  const toObject = getToObject({ to });
  if (toObject.pathname) {
    const currentPathname = getRouterData(getState(), ['location', 'pathname']);
    const currentLang = getLangFromPath(currentPathname);
    toObject.pathname = generateLangPath(toObject.pathname, currentLang);
  }
  return dispatch(historyReplace(toObject, state));
};
